import { Organization } from './organization.type';

export interface User {
  id: string;
  email: string;
  name: string;
  data: UserData;
  phone?: string;
  organization?: Organization; // Organization premium status
}

export interface UserData {
  role: Role;
  access: UserAccess[];
  language?: string | null;
  phone?: string;
  sector_manager_id?: string | null;
  managedAccountantIds?: string[];
  annual_salary?: number | null;
}

export interface UserAccess {
  organization_id: string;
  team_id: string | null;
  permissions: string[];
  custom_permissions?: string[];
}

export interface LoginRequest {
  email: string;
  password: string;
  turnstileToken?: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  name: string;
  phone: string;
  data: UserData;
}

export interface SignupWithOrganizationRequest {
  user: {
    email: string;
    password: string;
    name: string;
    phone: string;
  };
  organization: {
    name: string;
    email: string;
    data?: {
      organization_type?: string;
      sector?: string;
      monthly_invoices_count?: string;
      has_regular_accounts?: string;
      desired_service?: string;
    };
  };
  turnstileToken?: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export enum Role {
  ADMIN = 'admin',
  CUSTOMER_SUCCESS = 'customer_success',
  SECTOR_OPERATIONS_MANAGER = 'sector_operations_manager',
  ACCOUNTANT = 'accountant',
  CLEARING_OFFICER = 'clearing_officer',
  SALES = 'sales',
  ORGANIZATION = 'organization',
  ORGANIZATION_USER = 'organization_user',
  AUDITOR = 'auditor',
} 